var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-button",class:{
    'selected': _vm.selected,
    'correct': _vm.correct,
    'answered': _vm.answered,
    'large': _vm.size === 'large',
    'small': _vm.size === 'small',
    'extra-large': _vm.size === 'extra-large',
    'tiny': _vm.size === 'tiny',
    'is-sata': _vm.isSata,
  }},[(_vm.useAnswerLabels)?_c('span',{staticClass:"answer-label",class:{
      'selected': _vm.selected,
      'correct': _vm.correct,
      'answered': _vm.answered,
    }},[_vm._v("\n    "+_vm._s(_vm.index2Letter)+"\n  ")]):(_vm.iconName)?_c('icon',{staticClass:"icon-size-8",attrs:{"name":_vm.iconName,"variant":_vm.iconVariant}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }